<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ix"></a>
<p class="dedit"><em class="italic">To all my clients who were brave enough to embark on the inner journey and transform their lives.</em></p>
<p class="dedi"><em class="italic">Your joy is my deepest inspiration.</em></p>
<a id="page_x"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?16e8d6c3